module.exports = __webpack_public_path__ + "static/media/05.8fc8841a.png";